import { SelectedFilter } from '@src/pages/[...slug]/components/collection/domains/CollectionFilter'
import getColorFromUrl from '@src/quince-site-common/src/utils/extractColorFromURL'
import isBrowser from '@src/quince-site-common/src/utils/isBrowser'

// If current page has color filter in url, update color filters to use only that one filter
export const setInitialSelectedFilers = () => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
  let selectedFilers = new SelectedFilter({})
  if (isBrowser()) {
    const colorFromURl = getColorFromUrl(window.location.href)
    if (colorFromURl) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-argument
      selectedFilers = new SelectedFilter({
        colors: [colorFromURl],
      })
    }
  }
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return selectedFilers
}

export function getSelectedFiltersValuesString(filters: SelectedFilter | undefined | null) {
  if (!filters) return ''
  return Object.values(filters)
    .filter(value => Array.isArray(value))
    .flat(Infinity)
    .join('_')
}
